import React from 'react';
import Layout from '../components/layout/Layout';
import { QRCodeSVG } from 'qrcode.react';

const ARPage: React.FC = () => {
  const arDemoUrl = 'https://ar-demo.wodka.dev';
  const creativewacoUrl = 'https://creativewaco.org/bledsoe-miller-steam-center-murals';

  return (
    <Layout>
      <div className="bg-light">
        <div className="container mx-auto px-4 py-16">
          <h1 className="text-4xl font-black mb-12 text-black">Augmented Reality</h1>

          <div className="max-w-4xl mx-auto">
            {/* Introduction */}
            <div className="bg-white p-8 border-2 border-black mb-8">
              <h2 className="text-2xl font-bold mb-4 text-black">Interactive Murals with AR</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                I create murals that come alive through augmented reality technology.
                By integrating AR elements into my artwork, viewers can use their mobile devices
                to unlock interactive experiences, animations, and digital layers that enhance
                the physical mural.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                See examples of my AR mural work at{' '}
                <a
                  href={creativewacoUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black hover:opacity-70 underline font-semibold"
                >
                  Creative Waco - Bledsoe Miller STEAM Center
                </a>
              </p>
            </div>

            {/* Demo Section */}
            <div className="bg-white p-8 border-2 border-black">
              <h2 className="text-2xl font-bold mb-6 text-black">Try the AR Demo</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* QR Code Section */}
                <div className="flex flex-col items-center">
                  <h3 className="text-xl font-semibold mb-4 text-black">Scan to Experience</h3>
                  <div className="bg-white p-4 border-2 border-black inline-block">
                    <QRCodeSVG
                      value={arDemoUrl}
                      size={200}
                      level="H"
                      includeMargin={true}
                    />
                  </div>
                  <p className="text-sm text-gray-600 mt-4 text-center">
                    Scan this QR code with your phone to view the AR demo
                  </p>
                </div>

                {/* Trigger Image Section */}
                <div className="flex flex-col items-center">
                  <h3 className="text-xl font-semibold mb-4 text-black">AR Trigger Image</h3>
                  <div className="bg-white p-4 border-2 border-black inline-block">
                    <img
                      src="/letterA.png"
                      alt="AR Trigger - Letter A"
                      className="w-[200px] h-[200px] object-contain"
                    />
                  </div>
                  <p className="text-sm text-gray-600 mt-4 text-center">
                    Point your camera at this image to see a spinning globe in AR
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ARPage;
